import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { SharedModule } from '../shared/shared.module';
import { CalendarModule,  } from 'angular-calendar';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FooterComponent } from '../main-layout/footer/footer.component';
import { ModalsComponent } from './modals/modals.component';
import { StatsCardComponent } from './common/stats-card/stats-card.component';
import { StatsCard2Component } from './common/stats-card2/stats-card2.component';
import { DashboardComponent } from './dashboards/dashboard/dashboard.component';
import { HelpComponent } from './help/help.component';
import { LoginComponent } from './login/login/login.component';
import { RegisterComponent } from './login/register/register.component';
import { PasswordResetComponent } from './login/password-reset/password-reset/password-reset.component';
import { ConfirmPasswordResetComponent } from './login/confirm-password-reset/confirm-password-reset/confirm-password-reset.component';
import { ConfirmRegistrationComponent } from './login/confirm-registration/confirm-registration.component';
import { TradeHistoryComponent } from './transactions/trade-history/trade-history.component';
import { SettingsComponent } from './account/settings/settings.component';
import { BrokerSettingsComponent } from './account/broker-settings/broker-settings.component';
import { BrokerAccountComponent } from './account/broker-account/broker-account.component';
import { FiaComponent } from './fia/fia/fia.component';
import { MarketTradesComponent } from './marketTrades/market-trades/market-trades.component';
import { LoadingComponent } from './common/loading/loading.component';
import { FiaPinsComponent } from './common/fia-pins/fia-pins.component';
import { LoginBaseComponent } from './login/login-base.component';
import { LogoutComponent } from './login/logout/logout.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    BrowserModule,
    CalendarModule,
    SharedModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule
  ],
  declarations: [
    FooterComponent,
    ModalsComponent,
    StatsCardComponent,
    StatsCard2Component,
    DashboardComponent,
    HelpComponent,
    LoginComponent,
    RegisterComponent,
    PasswordResetComponent,
    ConfirmPasswordResetComponent,
    ConfirmRegistrationComponent,
    TradeHistoryComponent,
    SettingsComponent,
    BrokerAccountComponent,
    BrokerSettingsComponent,
    FiaComponent,
    MarketTradesComponent,
    LoadingComponent,
    FiaPinsComponent,
    LoginBaseComponent,
    LogoutComponent    
  ],
  exports: [
    FooterComponent,
    ModalsComponent,
    StatsCardComponent,
    StatsCard2Component,    
    DashboardComponent,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    BrowserAnimationsModule
  ],
  providers: [MatDatepickerModule],
  schemas: [NO_ERRORS_SCHEMA]
})
export class ViewsModule { }
